export const applyReasons = [
    {
        label: '投資上市櫃有價證券',
        value: '01',
    },
    {
        label: '期貨市場交易',
        value: '02',
    },
    {
        label: '不動產交易',
        value: '03',
    },
    {
        label: '其他理財',
        value: '04',
    },
    {
        label: '消費性支出',
        value: '05',
    },
    {
        label: '資金週轉',
        value: '06',
    },
    {
        label: '其他目的',
        value: '07',
    },
];

export const companyTypes = [
    { bhno: '1', label: '總公司' },
    { bhno: '2', label: '分公司' },
];
export const TransFlags = [
    {
        text: '進行結帳作業，\n 借款暫停服務',
        value: 'E1',
    },
    {
        text: '結帳作業中，暫時無法借款，請稍候，\n造成不便 敬請見諒！',
        value: 'E2',
    },
    {
        text: '資料轉檔中，暫時無法借款，請稍候，\n造成不便 敬請見諒！',
        value: 'E3',
    },
    {
        text: '銀行系統維護中，暫停借款，\n造成不便 敬請見諒！',
        value: 'E4',
    },
];
